import React from 'react';
import { Box, Container, Typography, Grid, Paper, Button } from '@mui/material';
import { motion } from 'framer-motion';
import { Link as RouterLink } from 'react-router-dom';

const Services = () => {
  return (
    <Box sx={{ py: 8 }}>
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          {/* Hero Section */}
          <Box sx={{ textAlign: 'center', mb: 8 }}>
            <Typography variant="h1" sx={{ color: 'primary.main', mb: 4 }}>
              Private Event Catering
            </Typography>
            <Typography variant="h5" sx={{ maxWidth: '800px', mx: 'auto', mb: 4 }}>
              Experience authentic whole hog BBQ at your next special event
            </Typography>
          </Box>

          {/* Event Types */}
          <Grid container spacing={4} sx={{ mb: 8 }}>
            {[
              {
                title: 'Corporate Events',
                description: 'Impress your clients and reward your team with an unforgettable BBQ experience',
                details: ['Company Picnics', 'Client Appreciation', 'Team Building', 'Holiday Parties']
              },
              {
                title: 'Weddings',
                description: 'Make your special day unique with our signature whole hog roast',
                details: ['Rehearsal Dinners', 'Wedding Receptions', 'Day-After Brunches', 'Engagement Parties']
              },
              {
                title: 'Private Parties',
                description: 'Create lasting memories with friends and family',
                details: ['Birthday Celebrations', 'Family Reunions', 'Graduation Parties', 'Holiday Gatherings']
              },
              {
                title: 'Special Events',
                description: 'Add southern charm to any occasion',
                details: ['Fundraisers', 'Church Events', 'Community Gatherings', 'Sports Events']
              }
            ].map((event, index) => (
              <Grid item xs={12} md={6} key={index}>
                <motion.div
                  whileHover={{ scale: 1.02 }}
                  transition={{ duration: 0.3 }}
                >
                  <Paper
                    elevation={3}
                    sx={{
                      p: 4,
                      height: '100%',
                      background: 'linear-gradient(rgba(123, 104, 238, 0.05), rgba(123, 104, 238, 0.1))'
                    }}
                  >
                    <Typography variant="h3" sx={{ color: 'primary.main', mb: 2 }}>
                      {event.title}
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      {event.description}
                    </Typography>
                    <Box component="ul" sx={{ pl: 3 }}>
                      {event.details.map((detail, idx) => (
                        <Typography component="li" key={idx} sx={{ mb: 1 }}>
                          {detail}
                        </Typography>
                      ))}
                    </Box>
                  </Paper>
                </motion.div>
              </Grid>
            ))}
          </Grid>

          {/* What's Included Section */}
          <Paper
            elevation={3}
            sx={{
              p: 6,
              mb: 8,
              background: 'linear-gradient(rgba(123, 104, 238, 0.05), rgba(123, 104, 238, 0.1))'
            }}
          >
            <Typography variant="h2" sx={{ color: 'primary.main', mb: 4, textAlign: 'center' }}>
              What's Included
            </Typography>
            <Grid container spacing={4}>
              <Grid item xs={12} md={6}>
                <Box>
                  <Typography variant="h4" sx={{ color: 'primary.main', mb: 2 }}>
                    The Experience
                  </Typography>
                  <Box component="ul" sx={{ pl: 3 }}>
                    <Typography component="li" sx={{ mb: 1 }}>
                      Professional pitmaster and service staff
                    </Typography>
                    <Typography component="li" sx={{ mb: 1 }}>
                      On-site whole hog roasting
                    </Typography>
                    <Typography component="li" sx={{ mb: 1 }}>
                      Custom setup and presentation
                    </Typography>
                    <Typography component="li" sx={{ mb: 1 }}>
                      Serving equipment and supplies
                    </Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box>
                  <Typography variant="h4" sx={{ color: 'primary.main', mb: 2 }}>
                    The Food
                  </Typography>
                  <Box component="ul" sx={{ pl: 3 }}>
                    <Typography component="li" sx={{ mb: 1 }}>
                      Whole hog BBQ with signature dry rub
                    </Typography>
                    <Typography component="li" sx={{ mb: 1 }}>
                      House-made BBQ sauces
                    </Typography>
                    <Typography component="li" sx={{ mb: 1 }}>
                      Traditional sides available upon request
                    </Typography>
                    <Typography component="li" sx={{ mb: 1 }}>
                      Customizable menu options
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Paper>

          {/* CTA Section */}
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="h2" sx={{ color: 'primary.main', mb: 4 }}>
              Ready to Plan Your Event?
            </Typography>
            <Typography variant="h5" sx={{ mb: 4 }}>
              Contact us for pricing and availability
            </Typography>
            <Button
              component={RouterLink}
              to="/contact"
              variant="contained"
              color="primary"
              size="large"
              sx={{ px: 6, py: 2 }}
            >
              Get in Touch
            </Button>
          </Box>
        </motion.div>
      </Container>
    </Box>
  );
};

export default Services;
